import { useState } from 'react'
import { Card, PageHeader, Pagination, PillFilter, SearchBox } from '../components/ui'
import { useList } from '../api/queries'
import type { Finding } from '../api/types'
import { FindingsTable } from '../features/tables/tables'
import { humanize } from '../lib/format'
import { useDebounced } from '../lib/hooks'

export function FindingsPage() {
  const [status, setStatus] = useState('open')
  const [severity, setSeverity] = useState('')
  const [search, setSearch] = useState('')
  const [pageNo, setPageNo] = useState(1)
  const q = useDebounced(search)
  const list = useList<Finding>('/api/findings/', { status, severity, search: q, page: pageNo, ordering: '-observed_on' })
  return (
    <div className="page">
      <PageHeader title="Hallazgos" subtitle="Surgen de observaciones críticas y medias; las órdenes de trabajo los corrigen" />
      <Card>
        <div className="toolbar"><SearchBox label="Buscar hallazgos" value={search} onChange={setSearch} /></div>
        <div className="pills" role="group" aria-label="Estado">{['open', 'resolved', 'dismissed', ''].map((s) => <PillFilter key={s} active={status === s} onClick={() => { setStatus(s); setPageNo(1) }}>{s ? humanize(s) : 'Todos'}</PillFilter>)}</div>
        <div className="pills" role="group" aria-label="Severidad">{['', 'critical', 'medium', 'low'].map((s) => <PillFilter key={s} active={severity === s} onClick={() => { setSeverity(s); setPageNo(1) }}>{s ? humanize(s) : 'Cualquier severidad'}</PillFilter>)}</div>
        <FindingsTable rows={list.data?.results} loading={list.isPending} error={list.error} onRetry={() => void list.refetch()} />
        {list.data ? <Pagination page={pageNo} pageSize={50} count={list.data.count} onPage={setPageNo} /> : null}
      </Card>
    </div>
  )
}
